/*
 * @Author: linguang linguang@nextmar.com
 * @Date: 2025-04-14 22:05:28
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-08-27 11:55:37
 * @FilePath: /code/zeelool-nextjs/src/components/Form/EmailInput/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import FormInput, { InputProps } from '@/components/Form/FormInput';
import { relationEmailMaxLength } from '@/utils/tools';
import { useTranslations } from 'next-intl';
import React from 'react';

// 邮箱输入组件的属性，继承自FormInput的属性
type EmailInputProps = Omit<InputProps, 'formatInput'>;

const EmailInput: React.FC<EmailInputProps> = ({
  name,
  placeholder,
  label,
  slotProps,
  layout = 'inline',
  clearable = true,
  ...restProps
}) => {
  const t = useTranslations('components.form.email');

  // 格式化邮箱输入
  const formatEmail = (emailValue: string): string => {
    // 格式化邮箱
    const formattedEmail = emailValue
      // eslint-disable-next-line no-useless-escape
      .replace(/[&%#!^?<>{}~|' *"\[\]\\:;|,()]/g, '')
      .replace(/[\u4E00-\u9FA5\u3000-\u303F\uFF00-\uFFEF]/g, '')
      .replace(/[""'']/g, '')
      .replace(
        /[^\u0020-\u007E\u00A0-\u00BE\u2E80-\uA4CF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF\u0080-\u009F\u2000-\u201F\r\n]/g,
        '',
      );

    return formattedEmail;
  };

  // 邮箱验证规则
  const emailRules = {
    required: t('validation.required'),
    pattern: {
      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      message: t('validation.invalid'),
    },
  };

  return (
    <FormInput
      label={label !== undefined ? label : t('label')}
      layout={layout}
      name={name}
      placeholder={placeholder || ''}
      autoComplete="off"
      rules={emailRules}
      formatInput={formatEmail}
      clearable={clearable}
      {...restProps}
      slotProps={{ htmlInput: { maxLength: 50 + relationEmailMaxLength }, ...slotProps }}
    />
  );
};

export default EmailInput;
